import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import BookingDetails from "../components/BookingFinal/BookingDetails";
import PassengerDetails from "../components/BookingFinal/PassengerDetails";
import FlightDetails from "../components/BookingFinal/FlightDetails";
import FareDetails from "../components/BookingFinal/FareDetails";
import FareBreakdown from "../components/FareBreakdown";
import Loading from "../common/Loading";
import { viewTicket } from "../actions/domestic/domesticFlightAction";
import moment from "moment";
import { Link } from "react-router-dom";

const DomesticTicketPage = () => {
  const params = new URLSearchParams(location.search);
  const [reservationResp, setReservationResp] = useState(null);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setIsLoading(true);
    if (params.get("success")) {
      dispatch(
        viewTicket(params.get("bookcode"), (resp) => {
          setReservationResp(resp);
          setIsLoading(false);

        })
      );
    }
    else {
      setIsLoading(false);
      setError(params.get("error"));
    }
  }, []);
  return (
    isLoading ? (
      <div>Loading...</div>
    ) : error ? <div>{error}</div> : (
      reservationResp &&
      <div className="border border-slate-200 max-w-screen-lg mx-auto my-3">
        <table className="text-left w-full  border-slate-500 align-top text-sm table-booking">
          <tr class="bg-slate-200"><td colspan="4"><h2 class="font-bold text-lg py-1">Booking Details</h2>
          </td>
          </tr>
          {reservationResp.FlightDetails.map((fd, i, array) =>
            <BookingDetailsTable flightData={fd} contact={reservationResp.ContactDetails} array={array} />
          )}
          <tr class="bg-slate-200"><td colspan="4"><h2 class="font-bold text-lg py-1">Passenger Details</h2>
          </td>
          </tr>
          {reservationResp && reservationResp.PassengerDetails.map((pd) =>
            <PassengerDetailsTable paxData={pd} />
          )}
          <tr class="bg-slate-200">
            <td colspan="3">
              <h2 class="font-bold text-lg py-1">Ticket Details</h2>
            </td>
            <td>
              <Link className="text-primary" to={reservationResp.TicketPdf} target="_blank" >Ticket PDF</Link>
            </td>
          </tr>
          {reservationResp && reservationResp.TicketDetails.map((td, i) =>
            <TicketDetailsTable ticketDetails={td} isRound={i == 1} />
          )}
          <tr class="bg-slate-200"><td colspan="4"><h2 class="font-bold text-lg py-1">Fare Breakdowns</h2>
          </td>
          </tr>
          {reservationResp && reservationResp.FareDetails.map((fd) =>
            <FareDetailsTable flightData={reservationResp.FlightDetails[0]} fareDetails={fd} />
          )}
        </table>
      </div>
    )
  );
};

export default DomesticTicketPage;


const BookingDetailsTable = ({ flightData, contact, array }) => {
  return (
    <>
      {array.length == 1 && <>
        <tr>
          <th>Contact Person</th>
          <td>{contact.Title} {contact.FirstName} {contact.LastName}</td>
          <th>ContactNo</th>
          <td>{contact.ContactNo}</td>
        </tr>
        <tr>
          <th>Email</th>
          <td>{contact.Email} </td>
        </tr>
      </>
      }

      <tr>
        <th>PNR Number</th>
        <td>{flightData.PNRNo}</td>
        <th>Airline</th>
        <td>{flightData.ValidatingAirline}</td>
      </tr>
    </>
  );
};

const PassengerDetailsTable = ({ paxData }) => {
  return (
    <>
      <tr>
        <th>Passenger</th>
        <td>{paxData.Title} {paxData.FirstName} {paxData.LastName}</td>
        <th>Nationality</th>
        <td> {paxData.Nationality} </td>
      </tr>
      <tr>
        <th>Passenger Type</th>
        <td>{paxData.PaxType} </td>
      </tr>
    </>
  );
};

const TicketDetailsTable = ({ ticketDetails, isRound }) => {
  return (
    <>
      <tr>
        <th>From - To</th>
        {!isRound ?
          <td>{ticketDetails.Origin} - {ticketDetails.Destination} </td> :
          <td>{ticketDetails.Destination} - {ticketDetails.Origin} </td>
        }
        <th>Nationality</th>
        <td> {ticketDetails.Nationality} </td>
      </tr>
      <tr>
        <th>Ticket Number</th>
        <td>{ticketDetails.TicketNo} </td>
        <th>Issued On</th>
        <td>{moment(ticketDetails.IssuedOn).format("lll")} </td>
      </tr>
      <tr>
        <th>Passenger</th>
        <td>{ticketDetails.Title} {ticketDetails.FirstName} {ticketDetails.LastName}</td>
      </tr>
    </>
  );
};

const FareDetailsTable = ({ flightData, fareDetails }) => {
  return (
    <>
      <tr>
        <th>Passenger Type</th>
        <td>{fareDetails.PaxCode} </td>
        <th>Booking Ref No</th>
        <td> {fareDetails.BookingRefNo} </td>
      </tr>
      <tr>
        <th>Airport Tax</th>
        <td>{fareDetails.AirportTax} </td>
      </tr>
      <tr>
        <th>Fare</th>
        <td>{fareDetails.Fare} </td>
      </tr>


      <tr>
        <th>Grand Total Tax</th>
        <td>{flightData.CurrencyCode} {flightData.GrandTotalTax}</td>
        <th>Grand Total Fare</th>
        <td>{flightData.CurrencyCode} {flightData.GrandTotalFare}</td>
      </tr>
    </>
  );
};


